/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { useLocale } from "@epic-mw/i18n";
import { isLangRtl, Direction } from "../utils/direction.utils";

export const useDirection = (): Direction => {
	const locale = useLocale();
	const isRtl = isLangRtl(locale);

	return isRtl ? "rtl" : "ltr";
};

export const useIsRtl = (): boolean => {
	const locale = useLocale();
	const isRtl = isLangRtl(locale);

	return isRtl;
};
